var map = {
	"./200340-judge.jpg": 10146,
	"./Accept.png": 28711,
	"./Customers.csv": 86412,
	"./Home1.png": 58121,
	"./Home2.png": 71494,
	"./HomePage.png": 16814,
	"./HomePage3.png": 83943,
	"./India_Post_Logo_With_Text (1).svg": 13693,
	"./Main-image.png": 78942,
	"./Offline.svg": 35697,
	"./Online.svg": 43565,
	"./TestPDFfile.pdf": 2049,
	"./Thumbs.db": 95920,
	"./Union.svg": 64313,
	"./Upload Car Image@3x.png": 59936,
	"./Vector.svg": 78994,
	"./a.xlsx": 5470,
	"./about.jpeg": 13869,
	"./add image.png": 5352,
	"./azad.png": 67464,
	"./azada.png": 51301,
	"./back.png": 84986,
	"./background.jpg": 63107,
	"./bank.png": 30281,
	"./banner-1.jpg": 61150,
	"./banner.jpg": 46599,
	"./banner.webp": 65444,
	"./butto online.png": 54458,
	"./button .png": 83372,
	"./call.png": 49532,
	"./cancel.png": 59685,
	"./car.png": 80941,
	"./carsoul.png": 2610,
	"./chat.png": 45695,
	"./chat1.jpg": 70850,
	"./chatbox.png": 96120,
	"./choose.webp": 60563,
	"./choose1.webp": 524,
	"./comment-dots_new.png": 90000,
	"./customer.png": 97438,
	"./dashboard/chrome.png": 98460,
	"./dashboard/contact-icon.png": 35988,
	"./dashboard/download.png": 11654,
	"./dashboard/files-icon.png": 90767,
	"./dashboard/firefox.png": 79110,
	"./dashboard/gallery.jpg": 71430,
	"./dashboard/gallery.png": 85185,
	"./dashboard/ie.png": 22266,
	"./dashboard/light.jpg": 13281,
	"./dashboard/light.png": 40841,
	"./dashboard/mouse-icon-sm.png": 76454,
	"./dashboard/mouse-icon.png": 58637,
	"./dashboard/project-icon.png": 80376,
	"./dashboard/rich-icon-sm.png": 29984,
	"./dashboard/rich-icon.png": 15655,
	"./dashboard/safari.png": 58287,
	"./dashboard/shopping-bag-icon-sm.png": 81412,
	"./dashboard/shopping-bag-icon.png": 25388,
	"./dashboard/tasks-icon.png": 5569,
	"./dashboard/teams-icon.png": 71197,
	"./ddddd.png": 39477,
	"./defaultlogo.png": 40866,
	"./document.png": 52811,
	"./drircation.png": 70380,
	"./driver.png": 81074,
	"./earning.png": 61722,
	"./earning.zip": 61848,
	"./emb.jpg": 18259,
	"./fac icon.png": 43834,
	"./faceBookicon_new.png": 15836,
	"./facebook.png": 36463,
	"./favicon.ico": 14329,
	"./footer-logo.png": 38959,
	"./global.jpg": 34443,
	"./help support.png": 14370,
	"./history.png": 78746,
	"./home.png": 12402,
	"./icon store.png": 32171,
	"./icone-de-filtre-grise.png": 19030,
	"./iconnn.png": 57110,
	"./image.png": 31169,
	"./image1.png": 43115,
	"./img_avatar2.png": 77655,
	"./indiapost.png": 71326,
	"./instagramicon_new.png": 68283,
	"./link.png": 7616,
	"./linkedin.png": 38518,
	"./loading.gif": 89163,
	"./locatin.png": 42753,
	"./location.png": 14752,
	"./locked.png": 21450,
	"./login image.png": 78400,
	"./logo-1-old.png": 26996,
	"./logo-color.png": 27430,
	"./logo.png": 74427,
	"./logo1-.png": 52214,
	"./logo1-1.png": 69565,
	"./logo1-old.png": 37099,
	"./logo1.png": 49461,
	"./logo11.png": 73771,
	"./logout.png": 26919,
	"./marker.png": 99997,
	"./menu bar.png": 53843,
	"./menu list.png": 3859,
	"./menu-icon.png": 59086,
	"./menu.png": 53325,
	"./mesaage.png": 51808,
	"./message.png": 54924,
	"./mm.docx": 69020,
	"./no-bank.png": 29687,
	"./no-docs.png": 98098,
	"./no-image.png": 17178,
	"./no-image.png_": 37139,
	"./not-found.png": 58060,
	"./not-found1.png": 92428,
	"./offile imae.png": 45710,
	"./password.png": 41425,
	"./pentagon.png": 22823,
	"./pentagon_1.png": 89226,
	"./phone.png": 64050,
	"./placeholder.jpg": 12463,
	"./placeholder.png": 70388,
	"./playstore.png": 71749,
	"./portalofindia.jpg": 17796,
	"./profiel scree.png": 25089,
	"./profile 1.png": 95903,
	"./profile.png": 91989,
	"./refund.png": 83701,
	"./replaced.png": 43931,
	"./send.jpg": 80438,
	"./send1.png": 86010,
	"./sfwit.png": 67542,
	"./svgviewer-png-output.png": 66279,
	"./tests-example.xls": 39405,
	"./text-message.gif": 91459,
	"./tick icon.png": 25424,
	"./ting-tong.gif": 47296,
	"./track.png": 39617,
	"./twitter.png": 46737,
	"./twitterImage_new.png": 74239,
	"./venue.png": 3246,
	"./w.doc": 99211,
	"./wallet.png": 82106,
	"./why_choose.jpg": 87425,
	"./widget/birds.png": 54638,
	"./widget/bread.png": 99407,
	"./widget/building.png": 9490,
	"./widget/disc.png": 79517,
	"./widget/flying.png": 67213,
	"./widget/glass.png": 47047,
	"./widget/noodles.png": 4126,
	"./wq.pdf": 5531,
	"./youtubeicon_new.png": 95810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;